import cx from "classnames"
import PropTypes from "prop-types"
import { Text } from "components/Text"

export function Badge(props) {
  const { label, size, className, color = "primary", ...rest } = props

  const classNames = cx(
    "rounded-sm",
    "border",
    "inline-flex",
    "border-primary-default",
    "text-primary-default",
    {
      "px-1": size == "small",
      "px-2 py-1": size == "big",

      "border-primary-default text-primary-default": color === "primary",
      "border-primary-light text-primary-light": color === "primary-light",
      "border-secondary-dark text-secondary-dark": color === "secondary",
    },
    className,
  )

  return (
    <Text
      variant={size == "big" ? "tag" : "caption"}
      className={classNames}
      {...rest}
    >
      {label}
    </Text>
  )
}

Badge.propTypes = {
  label: PropTypes.node.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf(["small", "big"]).isRequired,
  color: PropTypes.oneOf(["primary", "secondary", "primary-light"]),
}
